import { ApprovalFiltersI,
  ApprovalI,
  DedicatedOfferI,
  DedicatedOfferModelI,
  DeleteApprovalPayloadI,
  GetOrdersI,
  ShowLastDataPayload,
  SingleOfferI,
  SingleOfferModelI,
  UpdateDedicatedOfferModelI,
  UpdateSingleOfferModelI,
  approvalsTypes,
  getApprovalsTypes } from "./approvalsTypes";

export const getApprovalsQueue = (payload: ApprovalFiltersI): getApprovalsTypes => ({
  type: approvalsTypes.GET_APPROVALS_QUEUE,
  payload,
});

export const getApprovalsQueueSuccess = (payload: Array<ApprovalI>): getApprovalsTypes => ({
  type: approvalsTypes.GET_APPROVALS_QUEUE_SUCCESS,
  payload,
});

export const getApprovalsQueueFailure = (payload: string): getApprovalsTypes => ({
  type: approvalsTypes.GET_APPROVALS_QUEUE_FAILURE,
  payload,
});

export const setFilters = (payload: ApprovalFiltersI) => ({
  type: approvalsTypes.SET_FILTERS,
  payload,
});

export const loadMoreApprovals = (page: number) => ({
  type    : approvalsTypes.LOAD_MORE,
  payload : page,
});

export const fixUnfixScores = () => ({
  type: approvalsTypes.FIX_UNFIX_SCORES,
});

export const getOrders = (payload: GetOrdersI): getApprovalsTypes => ({
  type: approvalsTypes.GET_ORDERS,
  payload,
});

export const createDedicatedOffer = (
  payload: DedicatedOfferModelI,
  cbSuccess: () => void,
  cbFailure?: (error: string) => void,
): getApprovalsTypes => ({
  type: approvalsTypes.CREATE_DEDICATED_OFFER,
  payload,
  cbSuccess,
  cbFailure,
});

export const createDedicatedOfferSuccess = (payload: DedicatedOfferI): getApprovalsTypes => ({
  type: approvalsTypes.CREATE_DEDICATED_OFFER_SUCCESS,
  payload,
});

export const createDedicatedOfferFailure = (payload: string): getApprovalsTypes => ({
  type: approvalsTypes.CREATE_DEDICATED_OFFER_FAILURE,
  payload,
});

export const createSingleOffer = (
  payload: SingleOfferModelI,
  cbSuccess: () => void,
  cbFailure?: (error: string) => void,
): getApprovalsTypes => ({
  type: approvalsTypes.CREATE_SINGLE_OFFER,
  payload,
  cbSuccess,
  cbFailure,
});

export const createSingleOfferSuccess = (payload: SingleOfferI): getApprovalsTypes => ({
  type: approvalsTypes.CREATE_SINGLE_OFFER_SUCCESS,
  payload,
});

export const createSingleOfferFailure = (payload: string): getApprovalsTypes => ({
  type: approvalsTypes.CREATE_SINGLE_OFFER_FAILURE,
  payload,
});

export const updateOfferQueue = (
  payload: UpdateSingleOfferModelI | UpdateDedicatedOfferModelI,
  cbSuccess: () => void,
  cbFailure?: (error: string) => void,
): getApprovalsTypes => ({
  type: approvalsTypes.UPDATE_OFFER_QUEUE,
  payload,
  cbSuccess,
  cbFailure,
});

export const updateOfferQueueSuccess = (
  payload: UpdateSingleOfferModelI | UpdateDedicatedOfferModelI,
): getApprovalsTypes => ({
  type: approvalsTypes.UPDATE_OFFER_QUEUE_SUCCESS,
  payload,
});

export const updateOfferQueueFailure = (payload: string): getApprovalsTypes => ({
  type: approvalsTypes.UPDATE_OFFER_QUEUE_FAILURE,
  payload,
});

export const deleteApprovalQueue = (
  payload: { approval_id: number },
  scb: () => void,
  fcb: (error: string) => void,
): getApprovalsTypes => ({
  type            : approvalsTypes.DELETE_APPROVAL_QUEUE,
  payload,
  successCallback : scb,
  failureCallback : fcb,
});

export const deleteApprovalQueueSuccess = (payload: DeleteApprovalPayloadI): getApprovalsTypes => ({
  type: approvalsTypes.DELETE_APPROVAL_QUEUE_SUCCESS,
  payload,
});

export const deleteApprovalQueueFailure = (payload: string): getApprovalsTypes => ({
  type: approvalsTypes.DELETE_APPROVAL_QUEUE_FAILURE,
  payload,
});

export const updateStatusQueue = (payload: any, scb: () => void, fcb: (error: string) => void): getApprovalsTypes => ({
  type            : approvalsTypes.UPDATE_STATUS_QUEUE,
  payload,
  successCallback : scb,
  failureCallback : fcb,
});

export const updateStatusQueueSuccess = (payload: ApprovalI): getApprovalsTypes => ({
  type: approvalsTypes.UPDATE_STATUS_QUEUE_SUCCESS,
  payload,
});

export const updateStatusQueueFailure = (payload: string): getApprovalsTypes => ({
  type: approvalsTypes.UPDATE_STATUS_QUEUE_FAILURE,
  payload,
});

export const getApprovalsHistory = (payload: ApprovalFiltersI): getApprovalsTypes => ({
  type: approvalsTypes.GET_APPROVALS_HISTORY,
  payload,
});

export const getApprovalsHistorySuccess = (payload: Array<ApprovalI>): getApprovalsTypes => ({
  type: approvalsTypes.GET_APPROVALS_HISTORY_SUCCESS,
  payload,
});

export const getApprovalsHistoryFailure = (payload: string): getApprovalsTypes => ({
  type: approvalsTypes.GET_APPROVALS_HISTORY_FAILURE,
  payload,
});

export const setFiltersHistory = (payload: ApprovalFiltersI) => ({
  type: approvalsTypes.SET_FILTERS_HISTORY,
  payload,
});

export const loadMoreApprovalsHistory = (page: number) => ({
  type    : approvalsTypes.LOAD_MORE_HISTORY,
  payload : page,
});

export const fixUnfixScoresHistory = () => ({
  type: approvalsTypes.FIX_UNFIX_SCORES_HISTORY,
});

export const showLastData = (payload: ShowLastDataPayload) => ({
  type: approvalsTypes.SHOW_LAST_DATA,
  payload,
});

export const showLastDataSuccess = (payload: {
  approvals: Array<ApprovalI>;
  showMessage: boolean;
  section: "queue" | "history";
}) => ({
  type: approvalsTypes.SHOW_LAST_DATA_SUCCESS,
  payload,
});

export const showLastDataFailure = (payload: string) => ({
  type: approvalsTypes.SHOW_LAST_DATA_FAILURE,
  payload,
});
